<div class="empty">
 
  <dsy-icon class="icon" name="help" library="system" size="24px" color="#5738ff" density="default" elevation="auto"></dsy-icon>
  
  <h3 class="title">{{ title() | translate }}</h3>

</div>
